import React from 'react';
import styled from 'styled-components';
import { Grid, Row, Column } from '@dls/web';

import Anchor from '../Anchor';

import logo from '../../assets/images/logo.png';

const StyledHeader = styled.header`
  display: flex;
  align-items: center;
  width: 100%;
  height: 64px;
  ${p => p.theme.media.md`
  height: 120px;
  `};
  background-color: ${p => p.theme.colours.white};
  padding: ${p => p.theme.spacing(2)} 0;
  border-top: 4px solid ${p => p.theme.colours.primary};
  box-shadow: 0 2px 5px 0 ${p => p.theme.colours.grey_400};
`;

const Logo = styled.img`
  height: 44px;
  vertical-align: middle;
`;

const BasicHeader = () => (
  <StyledHeader>
    <Grid>
      <Row middle="sm">
        <Column>
          <Anchor href={process.env.GATSBY_AEM_URL}>
            <Logo src={logo} alt="Singtel" />
          </Anchor>
        </Column>
      </Row>
    </Grid>
  </StyledHeader>
);

export default BasicHeader;
